/**
 * Zentralisierte Konfiguration für die API-URL.
 * Fallback auf api. subdomain falls auf der mylab-Infrastruktur ohne VITE_API_URL gebaut wurde.
 */
export const API_BASE_URL =
  import.meta.env.VITE_API_URL ||
  (window.location.hostname.endsWith('codelab.mylab.th-luebeck.de')
    ? `${window.location.protocol}//api.${window.location.hostname}`
    : '')
